import React, { Fragment, useState } from 'react';

import classNames                 from 'classnames';
import PropTypes                  from 'prop-types';
import { connect } from 'react-redux'
import store from 'store'
import { useNavigate, useLocation } from 'react-router-dom';
import { map } from 'lodash';
/*
| UI
*/
import Flex from '../../../common/Flex';
import ProfileDropdown from '../../ProfileDropdown';
/*
| ICONS
*/
import { PiListBulletsDuotone, PiListBold, PiReceiptDuotone, PiCalculatorDuotone, PiUsersDuotone } from "react-icons/pi";
import { MenuOutlined, MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import { IoCloseSharp } from 'react-icons/io5';
/*
| PAGES
*/
import CustomerForm from '../../../customers/components/CustomerForm';
/*
| IMAGES
*/
// import Logo from '../../Logo';
// import VarexeLogo from 'components/common/VarexeLogo';

import { Layout, Button, Space, Tooltip, Drawer } from "antd";
import { TodoTopNavbarDrawer } from '../../../todos/todo-topnavbar';

const { Header } = Layout;

const mapStateToProps = ({  settings, auth }) => ({
  isMenuCollapsed: settings.isMenuCollapsed,
  isMobileView: settings.isMobileView,
  isMobileMenuOpen: settings.isMobileMenuOpen,
  isMenuUnfixed: settings.isMenuUnfixed,
  isMenuShadow: settings.isMenuShadow,
  leftMenuWidth: settings.leftMenuWidth,
  menuColor: settings.menuColor,
  logo: settings.logo,
})

const NavbarTop = ({
  dispatch,
  isMenuCollapsed,
  isMobileView,
  isMobileMenuOpen
}) => {

  const navigate = useNavigate();
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [formKey, setFormKey] = useState(0);

  const handleMenuToggle = () => {
    if (isMobileView) {
      // On mobile, toggle the drawer
      dispatch({
        type: 'settings/CHANGE_SETTING',
        payload: {
          setting: 'isMobileMenuOpen',
          value: !isMobileMenuOpen,
        },
      })
    } else {
      // On desktop, toggle menu collapse
      dispatch({
        type: 'settings/CHANGE_SETTING',
        payload: {
          setting: 'isMenuCollapsed',
          value: !isMenuCollapsed,
        },
      })
    }
  }

  const handleOpenCustomerDrawer = () => {
    // Increment form key to reset the form when opening drawer
    setFormKey(prev => prev + 1);
    setDrawerVisible(true);
  };

  const handleCloseCustomerDrawer = () => {
    setDrawerVisible(false);
  };

  const handleCustomerFormCallback = (customerData) => {
    // Close drawer when form is submitted
    setDrawerVisible(false);
    // Reset form key for next time
    setFormKey(prev => prev + 1);
  };

  return (
    <Fragment>
      {/* Left Section - Menu Toggle */}
      <div style={{ display: "flex", alignItems: "center" }}>
        <Button
          color="default" variant="filled"
          icon={
            isMobileView 
              ? <MenuOutlined className='fs-1' />
              : (isMenuCollapsed ? <MenuUnfoldOutlined className='fs-1' /> : <MenuFoldOutlined className='fs-1' />)
          }
          onClick={handleMenuToggle}
          style={{ marginRight: 16 }}
        />
      </div>

      {/* Center Section - Action Buttons */}
      <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center" , gap: 6 }}>      
    
          <Tooltip title={isMobileView ? "New Invoice" : ""}>
            <Button 
              color="default" 
              variant="filled"
              icon={<PiReceiptDuotone style={{fontSize: '1.2rem'}} />}
              onClick={() => navigate('/invoices/new')}
            >
              {!isMobileView && ' New Invoice'}
            </Button>
          </Tooltip>
          
          <Tooltip title={isMobileView ? "New Estimate" : ""}>
            <Button 
              color="default" 
              variant="filled"
              icon={<PiCalculatorDuotone style={{fontSize: '1.2rem'}} />}
              onClick={() => navigate('/estimates/new')}
            >
              {!isMobileView && ' New Estimate'}
            </Button>
          </Tooltip>
          
          <Tooltip title={isMobileView ? "New Customer" : ""}>
            <Button 
              color="default" 
              variant="filled"
              icon={<PiUsersDuotone style={{fontSize: '1.2rem'}} />}
              onClick={handleOpenCustomerDrawer}
            >
              {!isMobileView && ' New Customer'}
            </Button>
          </Tooltip>

      </div>

      {/* Right Section - Settings & Profile */}
      <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", gap: 6 }}>
        <TodoTopNavbarDrawer />
        <ProfileDropdown />
      </div>

      {/* Customer Form Drawer */}
      <Drawer
        title="Create Customer"
        placement="right"
        size={800}
        resizable
        onClose={handleCloseCustomerDrawer}
        open={drawerVisible}
        closable={true}
        keyboard={true}
        extra={
          <Button
            onClick={handleCloseCustomerDrawer}
            icon={<IoCloseSharp />}
          >
            Close
          </Button>
        }
      >
        <CustomerForm
          key={formKey}
          customerFormCallBack={handleCustomerFormCallback}
        />
      </Drawer>
    </Fragment>
  )
};

export default connect(mapStateToProps)(NavbarTop)
